import { render, staticRenderFns } from "./SelectWeekdayInput.vue?vue&type=template&id=65d161d8&scoped=true"
import script from "./SelectWeekdayInput.vue?vue&type=script&lang=ts"
export * from "./SelectWeekdayInput.vue?vue&type=script&lang=ts"
import style0 from "./SelectWeekdayInput.vue?vue&type=style&index=0&id=65d161d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d161d8",
  null
  
)

export default component.exports